var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VueRecaptcha',{ref:"recaptcha",attrs:{"id":"g-recaptcha","sitekey":"6Ld6x-kdAAAAAAyuhl62pqCfdb67R1y3q0BOdpb2"},on:{"verify":_vm.onVerify}})}
var staticRenderFns = []

export { render, staticRenderFns }